import styles from './Hero.section.module.css'
import bg from "/bg.jpg"
import { Check } from 'lucide-react'
import { NavLink } from 'react-router'


export default function HeroSection() {
  return (
    <section className={styles.section}>
        <div className={styles.image}>
            <img src={bg} fetchPriority='high' loading='eager' alt="Hero image"/>
        </div>
        <div className={styles.hero}>
            <div className={styles.content}>
                <h1>
                    Gestiona a tus proveedores de forma <span>inteligente y centralizada</span>
                </h1>
                <p>
                    Simplifica el control de el cumplimiento normativo de tus proveedores en una única plataforma segura.
                </p>
                <div className={styles.features}>
                    <div className={styles.feature}>
                        <span className={styles.check}><Check /></span>
                        <span>Seguimiento automático de vencimientos y documentos</span>
                    </div>                    
                    <div className={styles.feature}>
                        <span className={styles.check}><Check /></span>
                        <span>Alertas inteligentes para cambios y renovaciones</span>
                    </div>                    
                    <div className={styles.feature}>
                        <span className={styles.check}><Check /></span>
                        <span>Acceso controlado y auditoría de documentos</span>
                    </div>
                </div>
                <div className={styles.buttons}>                
                    <NavLink to={"login"} className={styles.getstarted}>Entrar al panel</NavLink>
                </div>
            </div>
            
        </div>
    </section>  
  )
}
